
const labelNames = {
  totalLawsInYear: {
    id: 1,
    name: 'Кол-во законов',
    color: "#8EC3A7"
  },
  wholeLawTypeInYear: {
    id: 2,
    name: 'Кол-во цельных законов',
    color: "#fec703"
  },
  normsWithoutByLawsInYear: {
    id: 3,
    name: "Количество норм, по которым не принято подзаконных актов",
    color: "#720e9e"
  },
  normDevelopersInYear: {
    id: 4,
    name: "Кол-о государственных органов",
    color: "#ce252b"
  }
}

const developers = (data) => {
  if (!data) {
    return null
  }

  let graphData = {
    data: [],
    labels: {
      normDevelopersInYear: labelNames.normDevelopersInYear,
    },
    title: "Количество государственных органов, задействованных в реализации законов",
    nameElementId: "normDevelopers"
  }

  data.forEach(item => {
    graphData.data.push(
      {
        year: item.year,
        data: [
          {
            label_id: 4,
            value: item.normDevelopersInYear
          }
        ]
      },
    )
  });

  return graphData
}

const norms = (data) => {
  if (!data) {
    return null
  }

  let graphData = {
    data: [],
    labels: {
      normsWithoutByLawsInYear: labelNames.normsWithoutByLawsInYear,
    },
    title: "Нормы, по которым не принято подзаконных актов",
    nameElementId: "normNotPA"
  }

  data.forEach(item => {
    graphData.data.push(
      {
        year: item.year,
        data: [
          {
            label_id: 3,
            value: item.normsWithoutByLawsInYear
          }
        ]
      },
    )
  });

  return graphData
}

const year = (data) => {
  if (!data) {
    return null
  }

  let graphData = {
    data: [],
    labels: {
      totalLawsInYear: labelNames.totalLawsInYear,
      wholeLawTypeInYear: labelNames.wholeLawTypeInYear
    },
    title: "Грузооборот на единицу ВВП",
    nameElementId: "cargoTurneverGDP"
  }

  data.forEach(item => {
    graphData.data.push(
      {
        year: item.year,
        data: [
          {
            label_id: 1,
            value: item.totalLawsInYear
          },
          {
            label_id: 2,
            value: item.wholeLawTypeInYear
          }
        ]
      },
    )
  });

  return graphData
}

export default {
  year,
  norms,
  developers
}